<template>
   <div class="w-screen h-auto bg-slate-700 text-slate-100 p-4 pt-16">
    <ul class="menu flex flex-wrap justify-start">
        <li><Link href="/admin/dashboard">Back</Link></li>
    </ul>
    <ul>
        <li>
            {{ firstSlug(page) }} / {{ page.page_title }} ({{ page.id }})
            <div class="flex flex-wrap ml-12">
                <ul class="w-1/2">
                    <li><button @click="addingPage=true" class="bg-slate-300 text-black px-3">Add Page</button></li>
                    <li v-if="addingPage" class="border my-4 p-4">
                        <ul>
                            <li>
                                <label for="slug" class="block">slug</label>
                                <input id="slug" type="text" v-model="newpage.slug">
                            </li>
                            <li>
                                <label for="title" class="block">title</label>
                                <input id="title" type="text" v-model="newpage.page_title">
                            </li>
                            <li>
                                <label for="menu_title" class="block">menu title</label>
                                <input id="menu_title" type="text" v-model="newpage.menu_title">

                            </li>
                            <li>
                                <label for="pid" class="block">parent id</label>
                                <input id="pid" type="text" name="parent_id" :value="page.id" disabled>
                            </li>
                            <li>
                                <label for="class" class="block">class</label>
                                <input id="class" type="text" v-model="newpage.class">
                            </li>
                            <li>
                                <label for="order" class="block">order</label>
                                <input id="order" type="text" v-model="newpage.order">
                            </li>
                            <li><button @click="addNewPage" class="bg-blue-500 text-white my-2 px-16">Add</button></li>
                        </ul>
                    </li>
                    <li v-for="c in page.children" :key="c.id">
                        <Link :href="`/admin/admin-page/${c.id}`"> {{ c.id }} {{ c.slug }} {{ c.order }}</Link>
                    </li>
                </ul>
                <ul class="w-full">
                    <li>
                        <button class="border p-2 bg-slate-900" @click="addingSection=true">
                              <vue-feather type="plus" size="24px" class="-mb-[6px]"/> Add Section
                        </button>
                        <ul v-if="addingSection" class="sections flex flex-wrap gap-4">
                            <li @click="addSection('Carousel')">Carousel</li>
                            <li @click="addSection('Gallery')">Gallery</li>
                            <li @click="addSection('Video')">Video</li>
                            <li @click="addSection('Paragraph')">Paragraph</li>
                        </ul>

                    </li>
                    <li v-for="po in page.page_objects" :key="po.id">
                        {{ po.objectable_type }} ({{po.objectable_id }})
                        <Carousel v-if="po.objectable_type=='App\\Models\\Carousel'" :items="po.objectable?.items" :id="po.objectable_id"/>
                        <Gallery v-if='po.objectable_type=="App\\Models\\Gallery"' :images="po.objectable?.images" :id="po.objectable_id" />
                        <VideoObject v-if="po.objectable_type=='App\\Models\\Video'" :object="po" />
                        <ParagraphObject v-if="po.objectable_type=='App\\Models\\Paragraph'" :object="po.objectable" />
                        <MultiParagraphObject v-if="po.objectable_type=='App\\Models\\MultiParagraph'" :object="po" />
                    </li>
                </ul>
            </div>
        </li>
    </ul>
   </div>
</template>

<script>
import { Link, Head, router } from '@inertiajs/vue3';
import Carousel from '@/components/AuthComponents/Carousel.vue'
import Gallery from '@/components/AuthComponents/Gallery.vue'
import VideoObject from '@/components/AuthComponents/VideoObject.vue'
import ParagraphObject from '@/components/AuthComponents/ParagraphObject.vue'
import MultiParagraphObject from '@/components/AuthComponents/MultiParagraphObject.vue'
import { api } from '@/api';

export default {
   name: "PageEditor",
   props: ['auth', 'page'],
   components: { Carousel, Gallery, Head, Link, VideoObject, ParagraphObject, MultiParagraphObject },
   computed: {},
   data() {
       return {
            addingSection: false,
            addingPage: false,
            newpage: {}
       }
   },
   mounted() {

   },
   methods: {
        firstSlug() {
            if(typeof this.page?.all_parents == 'object') {
                return this.page.all_parents[0]?.slug;
            }else{
                return false;
            }
        },
        addSection(section) {
            router.post('/admin/add-section', {page_id: this.page.id, section: section });
        },
        addNewPage() {
            this.newpage.parent_id=this.page?.id;
            this.newpage.in_menu=1;

            router.post('/admin/add-page', this.newpage);
        }
   }
}
</script>
<style>
.admin a {
    color: #ffcc00 !important;
}
textarea {
    color: white;
    background-color: #333333;
}
ul.sections li {
    @apply border my-2 p-2;
}
</style>
<style scoped>
input {
    @apply text-black p-2;
}
</style>
